<template>
  <b-card class="bg-white rounded-xl px-4 eventss">
    <el-drawer
      :title="`${action} corporate events`"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <ValidationObserver
        tag="form"
        ref="obs1"
        @submit.prevent="addCorporateEventsData()"
        class="bg-white h-100"
      >
        <div class="px-5 pt-4">
          <label class="fsize16 text-dark font-semibold">Image</label>
          <!-- <ValidationProvider name="image" rules="image" v-slot="{ errors }"> -->
          <div>
            <FileUploader
              v-show="!image"
              :image="image"
              :onSuccess="handleSuccess"
              class="w-full my-1 display-none custmodal"
            />

            <div v-if="action != 'Edit'">
              <img
                v-if="image"
                :src="image"
                ref="cover"
                class="w-full my-1 display-none custmodal"
              />
              <div
                class="flex justify-center text-red"
                v-if="image"
                @click="handleRemove"
              >
                Remove image
              </div>
            </div>

            <div v-else>
              <img
                v-if="image"
                :src="
                  image.slice(0, 4) === 'data' ? image : `${$imageURL}/${image}`
                "
                ref="cover"
                class="rounded-full widtht20percent m-auto display-none custmodal"
              />
              <div
                class="text-center text-red"
                v-if="image"
                @click="handleRemove"
              >
                Edit image
              </div>
            </div>
            <span
              v-if="imageErr"
              class="flex justify-center small text-danger"
              >{{ msg.image }}</span
            >
          </div>
          <p class="fsize12 text-danger" v-if="showValidationErr">
            {{ validationErr }}
          </p>
          <!-- </ValidationProvider> -->

          <div class="">
            <label class="fsize16 text-dark font-semibold">Title</label>
            <ValidationProvider
              name="Title"
              rules="required"
              v-slot="{ errors }"
            >
              <el-input
                placeholder="Please input"
                class="w-full"
                v-model="eventTitle"
              ></el-input>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="mt-4">
            <label class="fsize16 text-dark font-semibold">Description</label>
            <ValidationProvider
              name="Description"
              rules="required"
              v-slot="{ errors }"
            >
              <el-input
                placeholder="Please input"
                class="w-full"
                type="textarea"
                v-model="eventDesp"
              ></el-input>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <!-- <div class="mt-4 grid grid-cols-2 gap-4"> -->
          <div class="mt-4">
            <label class="fsize16 text-dark font-semibold"
              >Event Date & Time</label
            >
            <ValidationProvider
              name="EventDate"
              rules="required"
              v-slot="{ errors }"
            >
              <el-date-picker
                v-model="eventDate"
                type="date"
                placeholder="Select date"
              >
              </el-date-picker>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider
              name="StartTime"
              rules="required"
              v-slot="{ errors }"
            >
              <!-- <el-time-select
                v-model="startTime"
                :picker-options="{
                  start: '07:00',
                  step: '00:60',
                  end: '23:00',
                }"
                placeholder="Select time"
              >
              </el-time-select> -->
              <date-picker
                v-model="eventTime"
                format="HH:mm"
                value-type="format"
                type="time"
                class="w-full"
                :config="configdateTimePicker"
                placeholder="HH:mm"
                key="renderCount"
              >
              </date-picker>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <!-- <div class="mt-4">
            <label class="fsize16 text-dark font-semibold"
              >End Date & Time</label
            >
            <ValidationProvider
              name="EndDate"
              rules="required"
              v-slot="{ errors }"
            >
              <el-date-picker
                v-model="endDate"
                type="date"
                placeholder="Select date "
              >
              </el-date-picker>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider
              name="EndTime"
              rules="required"
              v-slot="{ errors }"
            >
              <el-time-select
                v-model="endTime"
                :picker-options="{
                  start: '07:00',
                  step: '00:60',
                  end: '23:00',
                }"
                placeholder="Select time"
              >
              </el-time-select>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div> -->
          <!-- <div class="mt-4">
          <label class="fsize16 text-dark font-semibold">Location</label>
          <el-input
            placeholder="Please input"
            class="w-full"
            type="textarea"
            v-model="location"
          ></el-input>
        </div> -->
          <!-- </div> -->
          <div class="mt-5 flex justify-center">
            <base-button
              outline
              class="px-8 fsize14 py-2 mx-1"
              type="primary"
              @click="
                action == 'Add'
                  ? addCorporateEventsData()
                  : editCorporateEventsData()
              "
            >
              Submit
            </base-button>
          </div>
        </div>
      </ValidationObserver>
    </el-drawer>

    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Corporate Events</h2>
      </div>
      <!-- <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="actionPerform('', 'Add')"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Add
          Events
        </span>
      </base-button> -->
    </div>
    <div class="mt-5">
      <b-input-group class="">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          v-model="search"
          placeholder="Enter Search...."
          v-on:input="searchBy"
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="tableData"
        border
      >
        <el-table-column
          label="Image"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <img
              v-if="row.hasOwnProperty('bannerImage') && row.bannerImage != ''"
              :src="`${$imageURL}/${row.bannerImage}`"
              :alt="image"
            />
            <img
              v-else
              :src="`${$imageURL}/caregiversaathi/default/dummy%20image.jpg`"
              :alt="image"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="Title"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{ row.title }}
            </p>
          </template>
        </el-table-column>

        <el-table-column
          label="Description"
          min-width="250px"
          prop="description"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{ row.description }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="Event Date & Time"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              Date: {{ getDate(row.eventDate).split(",")[0] }}
            </p>
            <p class="font-semibold text-left name mb-0 text-sm">
              Time:
              {{ row.eventTime }}
            </p>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="End Date & Time"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              Date: {{ getDate(row.endDate).split(",")[0] }}
            </p>
            <p class="font-semibold text-left name mb-0 text-sm">
              Time:
              {{ row.endTime }}
            </p>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          label="Location"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{ row.location }}
            </p>
          </template>
        </el-table-column> -->
        <el-table-column
          label="Created Date"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{ getDate(row.createdAt) }}
            </p>
          </template>
        </el-table-column>

        <el-table-column
          label="Actions"
          min-width="100px"
          class-name="text-center"
        >
          <template v-slot="{ row }">
            <div class="flex justify-center items-center gap-1">
              <feather-icon
                @click="actionPerform(row, 'Edit')"
                icon="EditIcon"
                svgClasses="w-4 h-4 text-blue-500 cursor-pointer"
              ></feather-icon>
              <feather-icon
                @click="deleteCorporateEventsData(row)"
                icon="Trash2Icon"
                svgClasses="w-4 h-4 text-red-600 cursor-pointer"
              ></feather-icon>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="mt-5 flex justify-end">
      <el-pagination
        @current-change="
          (value) => {
            currentPage = value;
            getCorporateEventsData();
          }
        "
        layout="prev,pager,next"
        :per-size="10"
        :total="pageCount"
      >
      </el-pagination>
    </div>
  </b-card>
</template>

<script>
import moment from "moment";
import flatPicker from "vue-flatpickr-component";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "flatpickr/dist/flatpickr.css";
import FileUploader from "@/components/FileUploader";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
extend("required", {
  ...rules.required,
  message: "This field is required",
});
extend("integer", {
  ...rules.integer,
  message: "This field must be an integer",
});

export default {
  data() {
    return {
      drawer: false,
      direction: "rtl",

      // search
      search: "",
      tableData: [],

      // add/edit
      action: "",
      selectedId: "",
      selectedItem: "",
      eventTitle: "",
      eventDesp: "",

      location: "",

      eventDate: "",
      eventTime: "",
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
      },

      // image
      showValidationErr: false,
      validationErr: "This field is required",
      image: null,
      coverImage: null,
      imageErr: false,
      msg: {
        image: "",
      },

      // pagination
      currentPage: 1,
      pageCount: 0,

      pickerOptions: {
        shortcuts: [
          {
            text: "Today",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
        ],
      },

      renderCount: 0,
    };
  },
  components: {
    FileUploader,
    flatPicker,
    ValidationObserver,
    ValidationProvider,
    rules,
    extend,
    DatePicker,
  },
  methods: {
    searchBy: _.debounce(function (e) {
      this.getWellBeingData();
    }, 500),
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    clearAll() {
      this.action = "";
      this.selectedId = "";
      this.eventTitle = "";
      this.eventDesp = "";

      this.image = "";
      this.coverImage = "";

      this.eventDate = "";
      this.eventTime = "";

      this.location = "";
    },
    handleClose() {
      this.drawer = false;
      this.clearAll();
    },
    actionPerform(VALUE, ACTION) {
      if (ACTION == "Add") {
        this.drawer = true;
        this.action = ACTION;
      } else if (ACTION == "Edit") {
        this.drawer = true;
        this.action = ACTION;
        this.selectedItem = VALUE;
        this.selectedId = VALUE._id;
        this.eventTitle = VALUE.hasOwnProperty("title") ? VALUE.title : "";
        this.eventDesp = VALUE.hasOwnProperty("description")
          ? VALUE.description
          : "";

        this.image = VALUE.hasOwnProperty("bannerImage")
          ? VALUE.bannerImage
          : "";

        this.eventDate = VALUE.hasOwnProperty("eventDate")
          ? VALUE.eventDate
          : "";
        this.eventTime = VALUE.hasOwnProperty("eventTime")
          ? VALUE.eventTime
          : "";
      }
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));
        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    async getCorporateEventsData() {
      let offset = 0;
      let payload = {
        pagination: true,
      };

      if (this.currentPage == 1) {
        Object.assign(payload, { offset: offset });
      } else {
        offset = 10 * this.currentPage - 10;
        Object.assign(payload, { offset: offset });
      }
      if (this.search != "") {
        Object.assign(payload, { search: this.search });
      }
      let result = await this.$store.dispatch(
        "ffc/getCorporateEvents",
        payload
      );
      console.log(result, "RESULT");
      this.tableData = result.data.data;
      this.pageCount = result.data.count;
    },
    async addCorporateEventsData() {
      if (this.image == "" || this.image == null) {
        this.showValidationErr = true;
      } else {
        this.showValidationErr = false;
      }
      this.$refs.obs1.validate().then(async (success) => {
        if (success) {
          if (this.image != "" && this.coverImage != "") {
            const payload = new FormData();
            payload.append("title", this.eventTitle);
            payload.append("description", this.eventDesp);

            payload.append("bannerImage", this.coverImage);

            payload.append("eventDate", this.eventDate);
            payload.append("eventTime", this.eventTime);

            // payload.append("endDate", this.endDate);
            // payload.append("endTime", this.endTime);

            // payload.append("location", this.location);
            let result = await this.$store.dispatch(
              "ffc/addCorporateEvents",
              payload
            );
            this.coverImage = "";
            this.image = "";

            await this.clearAll();
            await this.handleClose();
            await this.getCorporateEventsData();
          }
        }
        // this.$refs["obs1"].reset();
        // this.$refs["obs1"].resetValidation();
        this.renderCount++;
      });
      // this.$refs["obs1"].reset();
      // this.$refs["obs1"].resetValidation();
    },
    async editCorporateEventsData() {
      const payload = new FormData();
      payload.append("_id", this.selectedId);
      if (
        this.selectedItem.hasOwnProperty("title") &&
        this.eventTitle != this.selectedItem.title
      ) {
        payload.append("title", this.eventTitle);
      }

      if (
        this.selectedItem.hasOwnProperty("description") &&
        this.eventDesp != this.selectedItem.description
      ) {
        payload.append("description", this.eventDesp);
      }

      if (
        this.selectedItem.hasOwnProperty("eventDate") &&
        this.eventDate != this.selectedItem.eventDate
      ) {
        payload.append("eventDate", this.eventDate);
      }

      if (
        this.selectedItem.hasOwnProperty("eventTime") &&
        this.eventTime != this.selectedItem.eventTime
      ) {
        payload.append("eventTime", this.eventTime);
      }

      // if (
      //   this.selectedItem.hasOwnProperty("endDate") &&
      //   this.endDate != this.selectedItem.endDate
      // ) {
      //   payload.append("endDate", this.endDate);
      // }

      // if (
      //   this.selectedItem.hasOwnProperty("endTime") &&
      //   this.endTime != this.selectedItem.endTime
      // ) {
      //   payload.append("endTime", this.endTime);
      // }

      let result = await this.$store.dispatch(
        "ffc/editCorporateEvents",
        payload
      );
      await this.clearAll();
      await this.handleClose();
      await this.getCorporateEventsData();
    },
    async deleteCorporateEventsData(ITEM) {
      let result = await this.$store.dispatch("ffc/deleteCorporateEvents", {
        _id: ITEM._id,
        isDeleted: true,
      });
      await this.getCorporateEventsData();
    },
  },
  async mounted() {
    await this.getCorporateEventsData();
  },
  watch: {
    drawer(value) {
      if (value == false) {
        this.$refs["obs1"].reset();
        this.$refs["obs1"].resetValidation();
      }
    },
    image(value) {
      if (value != "" && value != null) {
        this.showValidationErr = false;
      }
    },
  },
};
</script>
